module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductBoxColorVariants":{"title":"Barvy"}},"en":{"ProductBoxColorVariants":{"title":"Colors"}}}')
  delete Component.options._Ctor
}
